/**
 * Shared scroll reveal: targets `[data-ps-reveal]`; optional delays via `data-ps-reveal-delay`.
 * When animations apply, adds `ps-reveal-enhanced` on `document.body` (see block SCSS).
 */
(function () {
	'use strict';

	const SEL_REVEAL = '[data-ps-reveal]';
	const BODY_ENHANCED = 'ps-reveal-enhanced';
	const VISIBLE = 'is-ps-visible';

	/**
	 * @param {HTMLElement} el
	 */
	function applyRevealDelayFromAttr(el) {
		const raw = el.getAttribute('data-ps-reveal-delay');
		if (raw == null || String(raw).trim() === '') {
			return;
		}
		let v = String(raw).trim();
		if (!/s$/i.test(v) && !/^calc\(/i.test(v)) {
			const num = parseFloat(v);
			v = Number.isFinite(num) ? `${num}s` : v;
		}
		el.style.setProperty('--ps-reveal-delay', v);
	}

	function applyReducedMotion() {
		document.querySelectorAll(SEL_REVEAL).forEach((el) => {
			applyRevealDelayFromAttr(el);
			el.classList.add(VISIBLE);
		});
	}

	function applyAnimated() {
		const nodes = document.querySelectorAll(SEL_REVEAL);
		if (!nodes.length) {
			return;
		}

		document.body.classList.add(BODY_ENHANCED);

		const obs = new IntersectionObserver(
			(entries, o) => {
				entries.forEach((e) => {
					if (!e.isIntersecting) {
						return;
					}
					e.target.classList.add(VISIBLE);
					o.unobserve(e.target);
				});
			},
			{ root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
		);

		nodes.forEach((el) => {
			applyRevealDelayFromAttr(el);
			obs.observe(el);
		});
	}

	function init() {
		if (
			window.matchMedia('(prefers-reduced-motion: reduce)').matches
		) {
			applyReducedMotion();
		} else {
			applyAnimated();
		}
	}

	window.ParkSystemReveal = {
		init,
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
